module.exports = __webpack_public_path__ + "img/titleA.d76c4e06.png";